export default "__VITE_ASSET__BJkuFYeD__"